.page {
  padding: 24px 0 48px;
}

.backBtn {
  background: none;
  border: none;
  padding: 0;
  color: var(--color-text-secondary);
  font-size: 0.875rem;
  cursor: pointer;
  margin-bottom: 24px;
  display: inline-block;
  transition: color 0.15s;
}

.backBtn:hover {
  color: var(--color-accent);
}

/* ── Article ─────────────────────────────────────────────── */

.article {
  max-width: 740px;
  overflow: hidden;
}

.meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

/* Mirror badges from LeaderStory */
.categoryBadge {
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background-color: var(--color-accent-subtle);
  color: var(--color-accent);
  padding: 2px 6px;
  border-radius: 3px;
}

.rankBadge {
  font-size: 0.7rem;
  color: var(--color-text-muted);
}

.heroImage {
  width: 100%;
  max-height: 400px;
  object-fit: cover;
  border-radius: 6px;
  display: block;
  margin-bottom: 20px;
}

.floatFigure {
  float: left;
  max-width: 300px;
  margin: 0 20px 20px 0;
  border-radius: 6px;
  display: block;
  overflow: hidden;
}

.floatImage {
  width: 100%;
  display: block;
}

.title {
  font-size: 1.75rem;
  line-height: 1.25;
  font-weight: 700;
  color: var(--color-text-primary);
  margin: 0 0 8px;
}

.storyDate {
  font-size: 0.85rem;
  color: var(--color-text-muted);
  margin-bottom: 20px;
}

/* ── Markdown body ───────────────────────────────────────── */

.body {
  font-size: 1rem;
  line-height: 1.7;
  color: var(--color-text-primary);
}

.body h1,
.body h2,
.body h3,
.body h4 {
  color: var(--color-text-primary);
  margin: 1.4em 0 0.5em;
  line-height: 1.3;
}

.body h1 { font-size: 1.4rem; }
.body h2 { font-size: 1.2rem; }
.body h3 { font-size: 1.05rem; }
.body h4 { font-size: 0.95rem; }

.body p {
  margin: 0 0 1em;
}

.body ul,
.body ol {
  margin: 0 0 1em 1.5em;
  padding: 0;
}

.body li {
  margin-bottom: 0.3em;
}

.body a {
  color: var(--color-accent);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.body a:hover {
  opacity: 0.8;
}

.body strong {
  font-weight: 700;
}

.body em {
  font-style: italic;
}

/* ── Footer ──────────────────────────────────────────────── */

/* ── Related section ─────────────────────────────────────── */

.relatedSection {
  margin-top: 40px;
  padding-top: 24px;
  border-top: 1px solid var(--color-border);
}

/* ── Skeleton loading state ──────────────────────────────── */

.skeleton {
  max-width: 740px;
  animation: pulse 1.5s ease-in-out infinite;
}

.skeletonTitle {
  height: 36px;
  border-radius: 4px;
  background-color: var(--color-skeleton);
  margin-bottom: 20px;
  width: 70%;
}

.skeletonLine {
  height: 16px;
  border-radius: 4px;
  background-color: var(--color-skeleton);
  margin-bottom: 12px;
}

.skeletonLineShort {
  height: 16px;
  border-radius: 4px;
  background-color: var(--color-skeleton);
  width: 50%;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.5; }
}

/* ── Error state ─────────────────────────────────────────── */

.error {
  color: var(--color-text-secondary);
  font-size: 0.9rem;
  margin-top: 24px;
}
